import { useAsyncExecutor } from "async-executor-hook";
import { useState } from "react";

import { Authorization } from "../../common/AuthorizationCpt";
import { getErrorValueResponse } from "../../common/error/Error";
import loadingGreen from "../../images/loading_gray.gif";
import { FILE_FORMATS, HTTP_METHODS } from "../../utils/constants";
import { networkBackendRequest } from "../../utils/networkUtils";
import { uploadFileToS3 } from "../../utils/s3Upload";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import ConfirmModal from "../ConfirmModal/ConfirmModal";
import FileUploadInput from "../FileUploadInput/FileUploadInput";
import Modal from "../Modal/Modal";
import { Container, MainButton } from "./FileUploadCreditModalStyles";

function FileUploadCreditModal(props) {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [waitingServerResponse, updateWaitingServerResponse] = useState(false);
  const [showConfirmationModal, updateShowConfirmationModal] = useState(false);

  const InitialData = props.rowData;

  const onFileChange = (files) => {
    setSelectedFiles(files);
  };

  const [messageError, updateMessageError] = useState(false);

  const [rollBackMessage, updateRollBackMessage] = useState("");
  const [modalRollBack, updateModalRollBack] = useState(false);

  const toggleGetModal = () => {
    updateModalRollBack(!modalRollBack);
  };

  const [labelError, updateLabelError] = useState("");
  const [showModalCreditInsufficient, updateShowModalCreditInsufficient] =
    useState(false);
  const toggleModalCreditInsufficient = () => {
    updateShowModalCreditInsufficient(!showModalCreditInsufficient);
  };

  const updateInvoiceAsync = useAsyncExecutor(
    async (params: any) => {
      const creditAuthType =
        params.invoice.credit_payment_detail.payer_ruc.option === "consignee"
          ? "consignee-credit-authorization"
          : "cargo-agent-credit-authorization";

      const uploadS3 = await uploadFileToS3(
        creditAuthType,
        params.selectedFile,
        "autorizacion_uso_linea_credito_"
      ).then((resp) => {
        return resp;
      });
      const data = {
        credit_auth_doc: uploadS3[0],
        payer_ruc_option: params.invoice.credit_payment_detail.payer_ruc.option,
        payment_status_option: "pending_validation",
      };
      return await networkBackendRequest(
        `/invoices/payment-status/${params.invoice.invoice_id}/agent/`,
        HTTP_METHODS.PATCH,
        {},
        data
      ).then((response) => response.json());
    },
    {
      onSuccess: () => {
        updateWaitingServerResponse(false);
        toggleConfirmationModal();
        updateMessageError(false);
      },
      onError: (err) => {
        updateMessageError(err.error_code ? true : false);
        const errorMessage = getErrorValueResponse(err);
        updateLabelError(errorMessage);
        toggleConfirmationModal();
        props.updateWaitingServerResponse(false);
      },
    }
  );

  const rollbackQuotation = useAsyncExecutor(
    async (params: any) => {
      const data = {
        payer_ruc_option: params.invoice.credit_payment_detail.payer_ruc.option,
      };
      return await networkBackendRequest(
        `/invoices/rollback/${params.invoice.invoice_id}/`,
        HTTP_METHODS.PATCH,
        {},
        data
      ).then((resp) => resp.json());
    },
    {
      onSuccess: () => {
        onCancel();
        toggleModalCreditInsufficient();
        props.dataInvoicesRefresh();
      },
      onError: (error) => {
        const errorMessage = getErrorValueResponse(error);
        updateRollBackMessage(errorMessage);
        toggleGetModal();
      },
    }
  );

  const onFileUpload = () => {
    if (waitingServerResponse) return;
    updateWaitingServerResponse(true);
    const selectedFile = selectedFiles;
    updateInvoiceAsync.execute({
      invoice: InitialData,
      selectedFile: selectedFile,
    });
  };
  const onCancel = () => {
    props.hideModal();
  };

  const toggleConfirmationModal = () => {
    updateShowConfirmationModal(!showConfirmationModal);
  };

  return showConfirmationModal ? (
    <div>
      {!messageError ? (
        <ConfirmationModal
          title={
            selectedFiles.length > 1
              ? "Documentos subidos con éxito"
              : "Documento subido con éxito"
          }
          message={
            (selectedFiles.length > 1
              ? "La carga de los documentos ha sido exitosa."
              : "La carga del documento ha sido exitosa.") +
            " Haga clic en entendido o cierre el diálogo para continuar."
          }
          toggleModal={() => {
            onCancel();
            toggleConfirmationModal();
            props.dataInvoicesRefresh();
          }}
          onAccept={() => {
            onCancel();
            toggleConfirmationModal();
            props.dataInvoicesRefresh();
          }}
        />
      ) : (
        <ConfirmModal
          toggleModal={toggleModalCreditInsufficient}
          title="Crédito insuficiente"
          message={labelError}
          haveAccept
          labelOnAccept="Volver a generar la factura"
          haveCancel
          labelOnCancel="Salir"
          styleOnAccept={{ background: "#002E6C" }}
          onAccept={() => {
            rollbackQuotation.execute({ invoice: InitialData });
          }}
          onCancel={() => {
            onCancel();
            toggleModalCreditInsufficient();
          }}
        ></ConfirmModal>
      )}
      {modalRollBack && rollBackMessage && (
        <ConfirmationModal
          message={rollBackMessage}
          onAccept={() => {
            toggleGetModal();
          }}
          title={`Atención`}
          toggleModal={() => {
            toggleGetModal();
          }}
        />
      )}
    </div>
  ) : (
    <Authorization actions={["invoice.update_invoice_upfront_manual"]}>
      <Modal onOutsideClick={onCancel}>
        <Container>
          <h1>
            {`Adjuntar documento de ${
              InitialData.credit_payment_detail.payer_ruc.option ===
              "cargo_agent"
                ? "AGENTE DE CARGA"
                : "AGENTE IMPORTADOR"
            }`}
          </h1>
          <FileUploadInput
            maxFiles={1}
            onValueChange={onFileChange}
            value={selectedFiles}
            formats={[FILE_FORMATS.IMAGE, FILE_FORMATS.PDF]}
          />
          <label style={{ color: "red", fontSize: 20, fontWeight: 15 }}>
            {messageError ? messageError : ""}
          </label>
          <MainButton
            disabled={selectedFiles.length === 0 || waitingServerResponse}
            onClick={onFileUpload}
          >
            {waitingServerResponse && (
              <img
                src={loadingGreen}
                width="50"
                height="50"
                alt="Processing request"
              />
            )}
            Enviar Documento
          </MainButton>
        </Container>
      </Modal>
    </Authorization>
  );
}
export default FileUploadCreditModal;
